import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.starts-with";
import _classCallCheck from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "C:/xampp/htdocs/simulador_new/node_modules/@babel/runtime/helpers/esm/createClass";

/** taken from https://github.com/spatie/form-backend-validation */
var Errors = /*#__PURE__*/function () {
  /**
   * Create a new Errors instance.
   */
  function Errors() {
    _classCallCheck(this, Errors);

    this.errors = {};
  }
  /**
   * Get all the errors.
   *
   * @param {object} errors
   */


  _createClass(Errors, [{
    key: "all",
    value: function all() {
      return this.errors;
    }
    /**
     * Determine if any errors exists for the given field or object.
     *
     * @param {string} field
     */

  }, {
    key: "has",
    value: function has(field) {
      var hasError = Object.prototype.hasOwnProperty.call(this.errors, field);

      if (!hasError) {
        var errors = Object.keys(this.errors).filter(function (e) {
          return e.startsWith("".concat(field, "."));
        });
        hasError = errors.length > 0;
      }

      return hasError;
    }
    /**
     * Determine if we have any errors.
     */

  }, {
    key: "any",
    value: function any() {
      return Object.keys(this.errors).length > 0;
    }
    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */

  }, {
    key: "get",
    value: function get(field) {
      if (this.errors[field]) {
        if (typeof this.errors[field] === 'string') {
          return this.errors[field];
        }

        return this.errors[field][0];
      }
    }
    /**
     * Record the new errors.
     *
     * @param {object} errors
     */

  }, {
    key: "record",
    value: function record(errors) {
      this.errors = errors;
    }
    /**
     * Clear a specific field, object or all error fields.
     *
     * @param {string|null} field
     */

  }, {
    key: "clear",
    value: function clear(field) {
      if (!field) {
        this.errors = {};
        return;
      }

      this.errors = window._.omit(this.errors, field);
    }
  }]);

  return Errors;
}();

export default Errors;